import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import store from './store';
import { queryClient } from './query/queryClient';
import { configureAppToast, syncAppToastDirection } from './utilities/appToast';
import { installFetchLanguageHeaders } from './utilities/installFetchLanguageHeaders';
import { installSessionGuard } from './utilities/sessionGuard';
import configureAntdModals from './utilities/configureAntdModals';

configureAppToast();
installFetchLanguageHeaders();
installSessionGuard();
configureAntdModals();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
    </React.StrictMode>
);

store.subscribe(() => {
  const language = store.getState()?.language?.language;
  syncAppToastDirection(language === 'ar');
});

